import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getProspectSearchWorkspace } from "@/app/actions/prospect-search/workspace/action";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  avatarId?: number;
  enabled?: boolean;
};

// One batched round-trip that seeds the summary / stats / imported-counts caches at once, so
// the page's gating reads aren't a serialized waterfall. Keyed on avatarId only (one-shot per
// avatar). The prospects list is loaded separately (cascade) so the page shows without it.
export function useFetchProspectSearchWorkspace(options: Options) {
  const { avatarId, enabled = true } = options;
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: [QueryKey.PROSPECT_SEARCH_WORKSPACE, avatarId],
    queryFn: async () => {
      const workspace = await getProspectSearchWorkspace(avatarId!);

      queryClient.setQueryData([QueryKey.PROSPECT_SEARCH_SUMMARY, avatarId], workspace.summary);
      queryClient.setQueryData([QueryKey.PROSPECTING_STATS, avatarId], workspace.stats);
      queryClient.setQueryData(
        [QueryKey.SOCIAL_IMPORTED_PROFILE_COUNTS, avatarId],
        workspace.importedCounts,
      );
      queryClient.setQueryData([QueryKey.PROSPECT_POOL, avatarId], workspace.pool);

      return workspace;
    },
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
  });
}
